package music.jammers.web.di

import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings
import music.jammers.client.shared.analytics.FirebaseAnalytics
import org.koin.dsl.module

val settingsModule = module {
    single<Settings> {
        StorageSettings()
    }
    single<FirebaseAnalytics> {
        FirebaseAnalytics()
    }
}